import { NICmsContentComponent } from '@icms/core/content';

export namespace NCmsComponentNewsletter {
    export const ID = 'newsletter';

    export interface IData extends NICmsContentComponent.IData {
        // source id
        source?: string;
        // custom success message
        successMessage?: string;
    }
}
